import { render, staticRenderFns } from "./KnImageDocItem.vue?vue&type=template&id=bc82c290"
import script from "./KnImageDocItem.vue?vue&type=script&lang=js"
export * from "./KnImageDocItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports